<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">

        <h1>About</h1>
        <p>
          This page was purely build for educational purposes on the basis of <a href="https://vuejs.org/" target="_blank">VueJS.</a>
        </p>
        <p>
          The contents (copy, images) have been re-used from various sources.
        </p>

      </div><!-- /.col-sm-12 -->
    </div><!-- /.row -->
  </div>
</template>

<script>
  export default {
    name: 'About',
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/About.vue